import type { GetS12nCertificateBannerProps, ProductDiscountPromoBannerProps } from 'bundles/page/types/Program';
import { isPaidMediaXDP } from 'bundles/unified-description-page-common/utils/isPaidMediaXDP';

type BannerProps =
  | {}
  | {
      productDiscountPromoBannerProps: ProductDiscountPromoBannerProps;
      getS12nCertificateBannerProps?: GetS12nCertificateBannerProps;
    };

const getBannerProps = (path: string, slug?: string): BannerProps => {
  if (!slug) {
    return {};
  }

  const isCDP = path?.includes('/learn') || path?.includes('/project');
  const slugProp = isCDP ? 'courseSlug' : 's12nSlug';
  const bannerProps = { [slugProp]: slug.toLowerCase() };

  return {
    productDiscountPromoBannerProps: bannerProps as ProductDiscountPromoBannerProps,
    ...(!isCDP
      ? {
          getS12nCertificateBannerProps: bannerProps as GetS12nCertificateBannerProps,
        }
      : {}),
  };
};

export const getPageHeaderProps = (params: {
  pathname: string;
  productSlug?: string;
  showSimplifiedPageHeader?: boolean;
}) => {
  const { pathname, productSlug, showSimplifiedPageHeader } = params;

  return showSimplifiedPageHeader || isPaidMediaXDP(pathname)
    ? {
        isPageWithSecondaryCta: true,
        logoWrapper: 'div',
        hideSearch: true,
        hideEnterprise: true,
        hideAdminLinks: true,
        hideMetaNav: true,
        hideNotificationCenter: true,
        showShoppingCart: false,
        hideLogIn: true,
        hideMobileNavLinks: true,
        disableHeaderLogoUserInteraction: true,
        enableCourseraHeaderLogoOnly: true,
        showLanguagesDropdown: true,
        ...getBannerProps(pathname, productSlug),
      }
    : {
        isPageWithSecondaryCta: true,
        logoWrapper: 'div',
        hideSearch: false,
        hideEnterprise: false,
        hideNotificationCenter: false,
        showShoppingCart: true,
        showLanguagesDropdown: true,
        ...getBannerProps(pathname, productSlug),
      };
};
